import graphql from './graphql';

const query = /* GraphQL */ `
  query UserAchievement_passedDevelopmentPlan($userId: ID!) {
    UserAchievement_passedDevelopmentPlan(userId: $userId) {
      completed
      progress
    }
  }
`;

const UserAchievementUsedAppFirstTime = async ({ userId }) =>
  graphql(query, { userId })
    .then(
      // eslint-disable-next-line camelcase
      ({ UserAchievement_passedDevelopmentPlan }) =>
        // eslint-disable-next-line camelcase
        UserAchievement_passedDevelopmentPlan
    )
    .catch(err => err);

export default UserAchievementUsedAppFirstTime;
